export default "__VITE_ASSET__DCsv9BLP__"